export enum TransactionType {
	SAVE_TRANSACTION_TYPE = 'SAVE_TRANSACTION_TYPE',
	SAVE_TRANSACTION_TYPE_SUCCESS = 'SAVE_TRANSACTION_TYPE_SUCCESS',
	SAVE_TRANSACTION_TYPE_FAIL = 'SAVE_TRANSACTION_TYPE_FAIL',

	GET_TRANSACTION_TYPES = 'GET_TRANSACTION_TYPES',
	GET_TRANSACTION_TYPES_SUCCESS = 'GET_TRANSACTION_TYPE_SUCCESS',
	GET_TRANSACTION_TYPES_FAIL = 'GET_TRANSACTION_TYPE_FAIL',
}
